export const AB_API_HOSTS = {
	development: 'https://dev-api.aofl.com',
	staging: 'https://dev-api.aofl.com',
	production: 'https://api.aofl.com'
};

export const DEVICE_KEY_MAP = {
	acquisition_source: 'acquisitionSource',
	device_id: 'deviceId',
	localeCode: 'localeCode',
	is_first_time_visit: 'isFirstTimeVisit',
	app_version: 'appVersion',
	country_code: 'viewerCountry',
	is_mobile_viewer: 'isMobileViewer',
	is_desktop_viewer: 'isDesktopViewer',
	is_webview: 'inApp',
	app_store: 'appStore',
	browser_platform: 'browserPlatform',
	// is_ios_viewer: 'isIosViewer',
	is_link_from_app: 'isLinkFromApp',
	is_aofl_product_uuid: 'isEmailLinkClick',
	is_link_from_email: 'isLinkFromEmail',
	is_automated_testing: 'isAutomatedTesting'
};

export const ACTIVE_EXPERIMENTS = {
	ABCM2_DESKTOP: {
		experimentKey: 'abcm-2-web-launch',
		variants: {
			test: 'test_variant',
			test1: 'test_variant_1',
			test2: 'test_variant_2',
			control: 'control_variant'
		}
	},
	ABCM2_MOBILE: {
		experimentKey: 'abcm-2-web-launch-mobile',
		variants: {
			test: 'test_variant',
			control: 'control_variant'
		}
	}
}

export const PROFILE = 'abcmouse';

export const EXPERIMENT_KEYS = [
	ACTIVE_EXPERIMENTS.ABCM2_DESKTOP.experimentKey,
	ACTIVE_EXPERIMENTS.ABCM2_MOBILE.experimentKey,
];

export const DATA_TYPES = {
	DEVICE: 'device',
	USER: 'user',
	SESSION: 'session',
	MASTER: 'master'
};
